import React,{useState} from 'react'
import { Field, Form, Formik } from 'formik'
import { TextField, Button } from '@material-ui/core'
import AuthService from '../services/AuthService'
import "../styles/MemberReset.css"
import {useHistory} from 'react-router-dom'


function MemberReset() {
    const [error,setError]=useState("")
    const [msg,setmsg]=useState(false)
    const history = useHistory();
    const iniVal = {
        pass: '',
        cnfpass: ''
    }

    const handleMemReset = (values) => {
        const result = JSON.parse(localStorage.getItem("result"))
        if(values.pass === values.cnfpass){
            if (values.pass.length<6){
                setmsg(true)
                setError("Minimum 6 characters required for password")
               
                

            }
            else{
                setmsg(false)
                AuthService.memberResetPassword(values.pass,result.mem_no).then(res => {
                    console.log(res,"mssssssssggggggg")
                    if (res.msg === "Password Reset Successfully!"){
                        alert(res.msg)
                        history.replace("/membership_login")
                    }else{
                        alert(res.msg)
                        history.replace('/member/deshboard')
                    }
                    
                })
            }
            
        }
        else{
            alert("Both passwords should be same");
        }
    }
    return (
        <div className="MresetMain">
            <div className="MresetContainer">
                <h4>Reset Password</h4>
                <Formik initialValues={iniVal} onSubmit={handleMemReset}>
                    {
                        () => (
                            <Form>
                                <div style={{display:'flex', flexDirection:'column', gap:'20px'}}>
                                    <Field name="pass" as={TextField}  label="Password" variant="outlined" type="password" />
                                    <Field name="cnfpass" as={TextField}  label=" Password" variant="outlined" type="password"/>
                                    {msg? <p style={{color:"red"}}>{error}</p>:
                                    <p></p> }
                                   
                                    <Button variant="contained" color="primary" type="submit">Reset Password</Button>
                                </div>
                            </Form>
                        )
                    }
                </Formik>
            </div>
        </div>
    )
}

export default MemberReset
